<a class="ts-logo" href="https://truescape.com" target="_blank">
    <img [src]="'./../../assets/logos/truescape-logo-' + type + '.png'" alt="truescape-logo" width="128" height="24" />
</a>
